import React, { useState } from "react";
import {
  MenuItem,
  ListItemIcon,
  ListItem,
  Menu,
  Button,
  ListItemText,
} from "@material-ui/core";
import { ExpandMore, Language } from "@material-ui/icons";
import { getLocale } from "../../utils/getLocale";
import { locales } from "../../config/i18n";
import { useTranslation } from "react-i18next";
import { setLocaleCookie } from "../../utils/setLocaleCookie";
import { flagsI18N } from "./Flags";

const LocaleSelectorMenu: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const currentLocale = getLocale();
  const [language] = currentLocale.toLowerCase().split("_");

  type HandleClick = (event: React.MouseEvent<HTMLButtonElement>) => void;
  const handleClick: HandleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  type HandleClose = () => void;
  const handleClose: HandleClose = () => {
    setAnchorEl(null);
  };

  type HandleItemClick = (locale: string) => void;
  const handleItemClick: HandleItemClick = (locale) => {
    setLocaleCookie(locale);
    const [language] = locale.split("_");
    i18n.changeLanguage(language);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        data-testid="localeSelectorButton"
        aria-controls="menu"
        aria-haspopup="true"
        variant="outlined"
        color="inherit"
        onClick={handleClick}
        startIcon={<Language />}
        endIcon={<ExpandMore />}
      >
        {language.toUpperCase()}
      </Button>
      <Menu
        data-testid="localeSelector"
        anchorEl={anchorEl}
        id="menu"
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ maxHeight: 600 }}
        disableScrollLock={true}
      >
        {locales.map((locale) => {
          const [, country] = locale.toLowerCase().split("_");
          return (
            <MenuItem
              data-testid={`locale_${locale}`}
              value={locale}
              key={locale}
              style={{ display: "flex", alignContent: "center" }}
            >
              <ListItem
                button
                onClick={(): void => handleItemClick(locale)}
                component="div"
                dense
                disableGutters
              >
                <ListItemIcon style={{ minWidth: "36px" }}>
                  <img src={flagsI18N[country]} alt="" height="16" />
                </ListItemIcon>
                <ListItemText>{t(`locales.${locale}`)}</ListItemText>
              </ListItem>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default LocaleSelectorMenu;
